import { useState } from "react";
import { TENANT_DOMAIN } from "../../utils/domain";
import { ERROR_MESSAGES } from "../../constant/constant";
import { useAxios } from "../../utils/useAxios";

/**
 * @typedef {object} LicensePriceData
 * @property {number} price_per_license - Price per individual license
 * @property {boolean} can_request_addon - This tell us that organization or school can request the
 * @property {currency} currency - Type of currency(INR, USD)
 * licenses addon or not
 */

/**
 * @description Custom hook to fetch license price for add-ons
 */
export const useGetLicensePrice = () => {
  const [priceData, setPriceData] = useState(
    /** @type {LicensePriceData | null | undefined} */ (undefined),
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { axiosInstance } = useAxios();

  /**
   * Fetch License Price for Add-ons
   * @async
   * @returns {Promise<void>}
   */
  const getLicensePrice = async () => {
    try {
      setLoading(true);
      setError("");

      const url = `${TENANT_DOMAIN}/billing/licenses/addons/price`;
      const response = await axiosInstance.get(url);

      setPriceData(response?.data?.data || null);
    } catch (err) {
      setPriceData(null);

      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    priceData,
    loading,
    error,
    getLicensePrice,
  };
};
